const APP_ROLE_LABELS: Record<string, string> = {
  SystemAdmin: 'System Admin',
  Admin: 'Admin',
  IncidentCommander: 'Incident Commander',
  OfficeDirector: 'Office Director',
  Headcounter: 'Headcounter',
  BackupHeadcounter: 'Recall Team',
  RecallTeam: 'Recall Team',
  ECTLead: 'ECT Lead',
  Zone1: 'Zone 1',
  Zone2: 'Zone 2',
  Zone3: 'Zone 3',
  LabZone: 'Lab Zone',
  AccountabilityCoordinator: 'Accountability Coordinator',
  ReadOnlyViewer: 'Read Only Viewer',
};

/** Display labels only; role UUIDs and database codes remain the assignment contract. */
export const getAppRoleLabel = (roleName: string): string =>
  APP_ROLE_LABELS[roleName] ?? roleName.replace(/([a-z])([A-Z])/g, '$1 $2');
